<template>
    <b-row class="min-vh-100">
        <b-col md="5" order="2" order-sm="2" order-md="1" class="auth-form-column">
            <div class="auth-form">
                <h1 v-html="$t('reset-password.title')"></h1>
                <p v-html="$t('reset-password.description')"></p>
                <!-- Reset password form -->
                <template v-if="!mailSent">
                    <b-form novalidate class="needs-validation" autocomplete="off">
                        <b-form-group :label="$t('reset-password.input.email_label')" label-for="email">
                            <b-form-input
                                id="email"
                                v-model="email"
                                type="email"
                                required
                                :placeholder="$t('reset-password.input.email_placeholder')"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors.email" :force-show="true" tag="span">{{ errors.email }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group class="mt-2">
                            <b-button type="submit" variant="primary" @click.prevent="sendResetPassword()" :disabled="!checkEmail()">
                                {{ $t('reset-password.button.reset') }}<span class="icon-arrow-btn ml-3"></span></b-button>
                        </b-form-group>
                    </b-form>
                </template>

                <!-- Reset password success block -->
                <template v-else>
                    <b-card :title="$t('reset-password.success_title')">
                        <b-card-text v-html="$t('reset-password.success_description')"></b-card-text>
                        <b-button variant="primary" @click="success">{{ $t('reset-password.button.success') }}</b-button>
                        <hr>
                        <b-card-text>
                            {{ $t('reset-password.success_resend_email') }}
                            <b-link @click="sendResetPassword(true)">{{ $t('reset-password.success_resend_email_link') }}</b-link>
                        </b-card-text>
                    </b-card>
                </template>
                <p class="font-weight-bold">{{ $t('reset-password.back_label') }} <router-link :to="{name:'login'}">{{ $t('reset-password.back_link') }}</router-link></p>
            </div>
        </b-col>
        <app-intro></app-intro>
    </b-row>
</template>

<script>
    import axios from 'axios';
    import { errors } from '../../mixins/errors';
    import { notifications } from '../../mixins/notifications';

    export default {
        name: 'reset-password',
        mixins: [
            errors,
            notifications
        ],
        data() {
            return {
                email: null,
                mailSent: false
            }
        },
        methods: {
            sendResetPassword(resendEmail = false) {
                axios.post(process.env.MIX_API_PREFIX + 'reset-password' + ((resendEmail) ? '/resend' : ''), {
                    email: this.email
                }).then(result => {
                    if (result.data.status === 200) {
                        if (resendEmail && this.mailSent) {
                            return this.pushNotification(result.data.message, 'success');
                        }

                        return this.mailSent = true;
                    }

                    return this.pushNotification(result.data.message, 'warning');
                }, errors => {
                    return this.handleResponseErrors(errors.response);
                });
            },
            success() {
                this.mailSent = !this.mailSent;
                this.email = null;
            },
            checkEmail() {
                return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)
            }
        },
        mounted() {
            this.validationHandler()
        }
    }
</script>
